import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Icon, IconNames } from '@triumph/design-system';
import { useAppContext } from '@/app/components/providers/AppContextProvider';
import { PageRoutes } from '@/app/components/router/routes';
import {
  IconTile,
  NoaWidgetCard,
  Subtitle,
  TextBlock,
  Title,
} from './NoaCenterWidget.StyledComponents';

export const NoaCenterWidget: React.FC = () => {
  const { t } = useTranslation('noaCenter');
  const { theme } = useAppContext();
  const navigate = useNavigate();

  return (
    <NoaWidgetCard
      type="button"
      onClick={() => navigate(PageRoutes.NOA_CENTER)}
      data-testid="noa-center-widget"
    >
      <IconTile>
        <Icon
          name={IconNames.Filetype_Document}
          id="noa-center-widget-icon"
          size="md"
          color={theme.colors.greyscale.gray50}
        />
      </IconTile>
      <TextBlock>
        <Title>{t('widget.title')}</Title>
        <Subtitle>{t('widget.subtitle')}</Subtitle>
      </TextBlock>
      <Icon
        name={IconNames.Chevron_Right}
        id="noa-center-widget-chevron"
        size="sm"
        color={theme.colors.greyscale.gray30}
      />
    </NoaWidgetCard>
  );
};
